import { TextField, MenuItem } from '@mui/material';

export const SPECIFIC_DATES_FILTER = 'Datas Específicas';

export const DATE_FILTER_OPTIONS = [
  'Mês atual',
  'Últimos 7 dias',
  'Últimos 30 dias',
  'Últimos 3 meses',
  'Últimos 6 meses',
  'Últimos 12 meses',
  'Anual',
  SPECIFIC_DATES_FILTER,
];

/**
 * Lista predefinida de opcoes de filtro de data - PADRONIZADA
 * Representa diferentes intervalos de tempo para filtragem de dados
 *
 * @type {string[]}
 */

/**
 * Componente de filtro de data para dashboards
 *
 * @component
 * @param {Object} props
 * @param {string} props.dateFilter - Filtro de data selecionado
 * @param {Function} props.onChange - Callback para mudanca de filtro
 * @param {number} [props.marginB=2] - Margem inferior
 * @param {string} [props.color] - Cor opcional ('white' ativa modo branco)
 *
 * @returns {React.ReactElement}
 */
export default function DashboardFilters({
  dateFilter,
  onChange,
  marginB = 2,
  color,
  hideSpecificDates = false,
  hideAnual = false,
  sx,
  fullWidth = false,
}) {
  const opcoesData = DATE_FILTER_OPTIONS.filter((option) => {
    if (hideAnual && option === 'Anual') return false;
    if (hideSpecificDates && option === SPECIFIC_DATES_FILTER) return false;
    return true;
  });

  const isWhite = color === 'white';
  const baseSx = {
    mb: marginB,
    width: 135.93,
    color: isWhite ? 'white' : undefined,
    bgcolor: isWhite ? 'transparent' : 'background.paper',
    borderRadius: 1,
    '& .MuiOutlinedInput-root': {
      color: isWhite ? 'white' : 'text.primary',
      borderRadius: 1.5,
      '& fieldset': {
        borderColor: isWhite ? 'white' : 'divider',
      },
      '&:hover fieldset': {
        borderColor: isWhite ? 'white' : '#667eea',
      },
      '&.Mui-focused fieldset': {
        borderColor: isWhite ? 'white' : '#667eea',
      },
    },
    '& .MuiInputLabel-root': {
      color: isWhite ? 'white' : 'text.secondary',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: isWhite ? 'white' : '#667eea',
      opacity: 1,
    },
    '& .MuiSelect-icon': {
      color: isWhite ? 'white' : 'text.secondary',
    },
    '& .MuiMenuItem-root': {
      color: isWhite ? 'white' : undefined,
    },
  };

  return (
    <TextField
      select
      label="Filtrar por período"
      value={dateFilter}
      onChange={(e) => onChange(e.target.value)}
      variant="outlined"
      size="small"
      fullWidth={fullWidth}
      sx={{ ...baseSx, ...(sx || {}) }}
    >
      {opcoesData.map((opt) => (
        <MenuItem key={opt} value={opt}>
          {opt}
        </MenuItem>
      ))}
    </TextField>
  );
}
